import { AdminSiteStatistics } from "./AdminSiteStatistics";

type TabEntry = { id: string; label: string };

/** Card titles on this page can differ from sidebar labels (e.g. settings-focused wording). */
const SECTION_CARD_TITLE: Partial<Record<string, string>> = {
  branches: "Branch settings",
  batches: "Batch settings",
  associations: "Association settings",
};

const BLURB: Record<string, string> = {
  news: "Create and edit news for your group.",
  branches: "Update your branch profile and photos.",
  batches: "Update your batch page, logo, and ExCo photo.",
  associations: "Update your association profile and media.",
  projects: "Add or edit projects linked to your group.",
  users: "Manage portal access: capabilities per email and entity.",
};

export function ScopedAdminLanding({
  sections,
  onSelectSection,
}: {
  sections: TabEntry[];
  onSelectSection: (id: string) => void;
}) {
  return (
    <div>
      <AdminSiteStatistics />
      <h2 className="mt-2 font-display text-2xl font-bold text-brand-blue">Welcome</h2>
      <p className="mt-2 max-w-2xl text-sm text-brand-blue/80">
        Choose where you want to work. You can always switch sections using the menu on the left.
      </p>
      <ul className="mt-8 grid gap-4 sm:grid-cols-2">
        {sections.map((s) => (
          <li key={s.id}>
            <button
              type="button"
              onClick={() => onSelectSection(s.id)}
              className="flex h-full w-full flex-col rounded-xl border border-brand-gray bg-white p-5 text-left shadow-sm transition hover:border-brand-maroon/40 hover:shadow-md"
            >
              <span className="font-display text-lg font-bold text-brand-blue">
                {SECTION_CARD_TITLE[s.id] ?? s.label}
              </span>
              <span className="mt-2 text-sm text-brand-blue/70">
                {BLURB[s.id] ?? "Open this section in the admin console."}
              </span>
              <span className="mt-4 text-xs font-bold uppercase tracking-wide text-brand-maroon">
                Open →
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
